<ion-content>
	<div class="quickLogger-logo" [ngClass]="{ ios: platform === platformName.IOS }">
		<ion-img src="./../../../../assets/icon/quickLogger-logo.png" alt="QuickLogger logo"></ion-img>
	</div>
	<div class="content">
		<div class="form">
			<form [formGroup]="loginForm" role="form" (ngSubmit)="onSubmit(loginForm.value)" autocomplete="off">
				<ion-item class="fusion-version">
					<div>
						<span>{{ 'login.fusionVersion' | translate }}</span>
					</div>
				</ion-item>
				<ng-container *ngIf="loginStep === loginStepEnum.username">
					<ion-item class="label">
						<ion-label>{{ 'login.username' | translate }}</ion-label>
					</ion-item>
					<ion-item>
						<ion-input formControlName="usernameControl" type="text"></ion-input>
					</ion-item>
				</ng-container>
				<ng-container *ngIf="loginStep === loginStepEnum.pin">
					<ion-item class="label pin">
						<div class="back-button" (click)="goBack()"><ion-icon class="icon-Arrow-Left"></ion-icon></div>
						<ion-label>{{ 'login.pin' | translate }}</ion-label>
					</ion-item>
					<ion-item>
						<app-otp-input [control]="pinControl"></app-otp-input>
					</ion-item>
				</ng-container>
				<ion-item>
					<button type="submit" [ngClass]="{ disabled: !loginForm.valid }">
						{{ getActionButtonText() }}
					</button>
				</ion-item>
				<ion-item class="no-api" (click)="noApiMode()">
					<div>
						<span>{{ 'login.noApiMode.suffix' | translate }}</span>
					</div>
				</ion-item>
				<ion-item class="registration" (click)="goToRegistration()">
					<div class="col-xs-12 registration">
						{{ 'login.registration.prefix' | translate }}
						<span>{{ 'login.registration.suffix' | translate }}</span>
					</div>
				</ion-item>
				<ion-item class="registration" (click)="goToResetPIN()">
					<div>
						{{ 'login.reset.prefix' | translate }}
						<span>{{ 'login.reset.suffix' | translate }}</span>
					</div>
				</ion-item>
				<ion-item class="device-id" (click)="displayDeviceId()">
					<div>
						{{ 'deviceId.prefix' | translate }}
						<span>{{ 'deviceId.suffix' | translate }}</span>
					</div>
				</ion-item>
			</form>
		</div>
	</div>
	<div class="datamine-logo">
		<ion-img src="./../../../../assets/icon/datamine-logo.png" alt="Datamine logo"></ion-img>
	</div>
</ion-content>
